import React from "react";
import { LocateFixed, Search } from "lucide-react";
import { Button } from "../ui/button";
import { ICON_STROKE } from "../ui/icon";
import NearbyEmptyIllustration from "./NearbyEmptyIllustration";

const NearbyEmptyState = ({
  variant = "empty",
  onUseLocation,
  onSearchAnotherArea,
}) => {
  if (variant === "pincode") {
    return (
      <div className="nearby-empty nearby-empty--compact">
        <NearbyEmptyIllustration />
        <h3 className="nearby-empty__title">Search by PIN code</h3>
        <p className="nearby-empty__message">
          Enter a 6-digit PIN above to find hospitals, police, and other emergency services in that area.
        </p>
      </div>
    );
  }

  return (
    <div className="nearby-empty nearby-empty--compact">
      <NearbyEmptyIllustration />
      <h3 className="nearby-empty__title">We couldn&apos;t find nearby emergency services</h3>
      <p className="nearby-empty__message">
        Try increasing your search radius, changing your PIN code, or using your current location.
        <span className="nearby-empty__reassure">We&apos;ll keep helping until you find assistance.</span>
      </p>
      <div className="nearby-empty__actions">
        {onUseLocation && (
          <Button type="button" variant="primary" fullWidth className="nearby-empty__btn-primary" onClick={onUseLocation}>
            <LocateFixed size={18} strokeWidth={ICON_STROKE} />
            Use My Current Location
          </Button>
        )}
        {onSearchAnotherArea && (
          <Button type="button" variant="secondary" fullWidth className="nearby-empty__btn-secondary" onClick={onSearchAnotherArea}>
            <Search size={18} strokeWidth={ICON_STROKE} />
            Search Another Area
          </Button>
        )}
      </div>
    </div>
  );
};

export default NearbyEmptyState;
